angular
    .module('WizApp')
    .service('SyncService', [
        '$http',
        '$filter',
        '$window',
        '$rootScope',
        'NoticeService',
        function ($http, $filter, $window, $rootScope, NoticeService) {
            var route = $filter('route');
            var trans = $filter('trans');

            function redirectToNetwork(type, action) {
                if (action === 'import') {
                    $window.location.href = route('wizbii_network_other', { type: 'last-friends', source: type });
                }
            }

            var SyncService = {
                listeners: {},
                facebook:  { login: facebookLogin, signup: facebookSignup, import: facebookImport },
                google:    { login: googleLogin, signup: googleSignup, import: googleImport },
                call:      call,
                on:        on,
                trigger:   trigger,
                getOpener: getOpener
            };

            angular.element($window).on('message', function (event) {
                $rootScope.$apply(function () {
                    SyncService.trigger(event);
                });
            });

            function on(type, action, ignoreRedirection, bypassNotice = false) {
                var self = this;
                var callbacks = {
                    _type:     type,
                    _action:   action,
                    _redirect: !ignoreRedirection,
                    _notice: !bypassNotice,
                    start:     angular.noop,
                    success:   angular.noop,
                    error:     angular.noop,
                    always:    angular.noop
                };

                if (!angular.isArray(self.listeners[type])) self.listeners[type] = [];

                self.listeners[type].push(callbacks);

                return {
                    when: function (eventName, callback) { callbacks[eventName] = callback; return this },
                    start: function (callback) { return this.when('start', callback) },
                    success: function (callback) { return this.when('success', callback) },
                    error: function (callback) { return this.when('error', callback) },
                    always: function (callback) { return this.when('always', callback) }
                };
            }

            function trigger(event) {
                var self = this;
                var data = event.data || event.originalEvent.data;
                var type = data && data.type;
                var listeners = angular.copy(self.listeners[type] || []).concat(angular.copy(self.listeners['*'] || []));
                var promises = {};
                var promise;
                var extraData;

                // If the message's type is not supported, return
                // i.e: twitter sends a message when opening the share popup
                if (!self[type]) return self;

                // If listeners has the wrong type or there's no listeners
                if (!angular.isArray(listeners) || !listeners.length) return self;

                angular.forEach(listeners, function (callbacks) {
                    // "*" is an alias to listen to any kind of message
                    // so it becomes the current message's type
                    // note that we are not altering the original object as `listeners` is just a copy
                    if (callbacks._type === '*') callbacks._type = type;

                    // If there's no method to handle such type & action, don't bother going forward
                    if (!angular.isFunction(self[callbacks._type][callbacks._action])) {
                        return;
                    }

                    extraData = [callbacks._type, callbacks._action, callbacks];

                    self.call(callbacks.start, extraData);

                    // avoid duplicate server requests
                    const alreadyExistingPromise = promises[callbacks._action];

                    promise =
                        alreadyExistingPromise ||
                        (promises[callbacks._action] = self[callbacks._type][callbacks._action](data.token));

                    promise
                        .success(function (res) {
                            if (res.status === 'ok') {
                                self.call(callbacks.success, extraData, arguments);
                                if (callbacks._redirect) self.call(redirectToNetwork, extraData);
                            } else {
                                self.call(callbacks.error, extraData, arguments);
                            }
                        })
                        .error(function () {
                            self.call(callbacks.error, extraData, arguments);
                        })
                        .error(function (err) {
                            if (!alreadyExistingPromise && callbacks._notice) {
                                NoticeService.error(err && err.error);
                            }
                        })
                        .finally(function () {
                            self.call(callbacks.always, extraData, arguments);
                        });
                });

                return self;
            }

            function call(fn, extras, data) {
                var self = this;
                var args;

                data = _.toArray(data || []);
                args = extras.concat(data);

                return fn.apply(self, args);
            }

            // return a function that opens a popup to the right url (depending on the arguments)
            function getOpener(action, type) {
                var title = trans('wizbii.onboarding.first.step2.popup' + type);
                var url =
                        action === 'login' ?
                            route('wizbii_onboardingui_login_' + type + '_connect') :
                            route('wizbii_onboardingui_login_' + type + '_connect')
                    ;

                return function () {
                    window.open(url, title, 'menubar=no, status=no, scrollbars=yes, menubar=no, width=600, height=600');
                };
            }

            function facebookLogin(token) {
                var url = route('wizbii_onboardingui_facebook_login_ajax');
                return $http.post(url, { token: token });
            }

            function facebookSignup(token) {
                var url = route('wizbii_onboardingui_facebook_login_ajax');
                return $http.post(url, { token: token });
            }

            function facebookImport(token) {
                var url = route('wizbii_onboardingui_facebook_import_ajax');
                return $http.post(url, { token: token });
            }

            function googleLogin(token) {
                var url = route('wizbii_onboardingui_google_login_ajax');
                return $http.post(url, { token: token });
            }

            function googleSignup(token) {
                var url = route('wizbii_onboardingui_google_login_ajax');
                return $http.post(url, { token: token });
            }

            function googleImport(token) {
                var url = route('wizbii_onboardingui_google_import_ajax');
                return $http.post(url, { token: token });
            }

            return SyncService;
        }
    ])
;
